import { createTheme } from '@mui/material/styles';

export const COLORS = {
  fairblock: '#648dff',
  encrypted: '#ffc107',
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#1a202c',
      paper: '#0d162e',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
});

export default theme;
